import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SplitText from '../common/SplitText';
import ElasticButton from '../ui/ElasticButton';
import ConstellationCanvas from './ConstellationCanvas';

const HeroSection = () => {
    const navigate = useNavigate();

    return (
        <section className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden bg-cyber-black">
            <ConstellationCanvas />

            {/* Radial Vignette for focus */}
            <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,transparent_0%,rgba(10,10,15,0.8)_100%)]" />

            {/* Bottom Fade to blend with next section */}
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-cyber-black to-transparent pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 pt-20">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8, ease: "circOut" }}
                >
                    <div className="inline-flex items-center space-x-2 bg-slate-900/50 backdrop-blur-md border border-slate-700 px-3 py-1 rounded-full text-sm font-medium text-blue-200 mb-8 shadow-lg shadow-blue-500/20">
                        <span className="flex h-2 w-2 rounded-full bg-blue-400 animate-pulse"></span>
                        <span>v2.0 High-Performance Engine</span>
                    </div>

                    <h1 className="text-4xl sm:text-6xl md:text-7xl lg:text-9xl font-extrabold tracking-tight text-white mb-4 sm:mb-8 leading-[1.1] drop-shadow-2xl">
                        <span className="block"><SplitText delay={0.2}>Build Faster.</SplitText></span>
                        <span className="block mt-2 sm:mt-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-teal-300 to-indigo-400 animate-gradient-x">
                            <SplitText delay={0.5}>Scale Infinite.</SplitText>
                        </span>
                    </h1>

                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 1, duration: 1 }}
                        className="mt-4 sm:mt-6 text-base sm:text-lg md:text-xl text-slate-300 max-w-3xl mx-auto mb-8 sm:mb-12 leading-relaxed font-medium px-4 sm:px-0"
                    >
                        The next-generation visual pipeline builder. <br className="hidden md:block" />
                        Engineered for <span className="text-white font-bold text-shadow-sm">zero-latency</span> workflows.
                    </motion.p>

                    <div className="flex flex-col sm:flex-row justify-center gap-6 items-center">
                        <ElasticButton primary onClick={() => navigate('/auth?mode=signup')}>
                            Get Started Free <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </ElasticButton>

                        <ElasticButton onClick={() => { }}>
                            <span className='text-slate-900'>View Templates</span>
                        </ElasticButton>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default HeroSection;
